import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import {
  getLocations,
  getLocation,
  createLocation,
  updateLocation,
  deleteLocation,
  clearLocalLocations,
  clearLocalActiveLocation
} from './actions';

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  location: { 
    id: '', 
    name: '', 
    display_name: '', 
    address: '', 
    synchronized: false, 
    slots_count: 0,
    updated_at: '' 
  },
  loading: { 
    all: false, 
    location: false 
  }
};

const  slice = createSlice({
  name: 'locations',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getLocations.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getLocations.fulfilled, (state, action) => {
        const { locations, pagination } = action.payload;
        
        state.loading.all = false;
        state.all.data = [...state.all.data, ...locations];
        state.all.pagination = pagination;
      })
      .addCase(getLocations.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getLocation.pending, (state) => {
        state.loading.location = true;
      })
      .addCase(getLocation.fulfilled, (state, action) => {
        const { location } = action.payload;
        const foundedLocation = !!_find(state.all.data, (m) => m.id === location.id);
        const updatedLocation = { ...state.location, ...location };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedLocation ? _map(state.all.data, (m) => m.id === location.id ? { ...m, ...location } : m) : [...[location], ...oldAllData]; 
        const pagination = foundedLocation ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.location = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedLocation) state.location = updatedLocation;       
      })
      .addCase(getLocation.rejected, (state) => {
        state.loading.location = false;
      })
      .addCase(createLocation.pending, (state) => {
        state.loading.location = true;
      })
      .addCase(createLocation.fulfilled, (state, action) => {
        const { location } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[location], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.location = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        state.location = location;
      })
      .addCase(createLocation.rejected, (state) => {
        state.loading.location = false;
      })
      .addCase(updateLocation.pending, (state) => {
        state.loading.location = true;
      })
      .addCase(updateLocation.fulfilled, (state, action) => {
        const { status, location } = action.payload;
        const data = _map(state.all.data, (m) => m.id === location.id ? { ...m, ...location } : m)
        const updatedLocation = { ...state.location, ...location };
        
        state.loading.location = false;
        if (status === 204) {
          state.all.data = data;
          state.location = updatedLocation;
        }     
      })
      .addCase(updateLocation.rejected, (state) => {
        state.loading.location = false;
      })
      .addCase(deleteLocation.pending, (state) => {
        state.loading.location = true;
      })
      .addCase(deleteLocation.fulfilled, (state, action) => {
        const { status, id } = action.payload;
        
        state.loading.location = false;
        if (status === 204) {
          state.all.data = _filter(state.all.data, (item) => item.id !== id);
          state.all.pagination = { ...state.all.pagination, count: state.all.pagination.count - 1, total_count: state.all.pagination.total_count - 1 };
          state.location = initialState.location;
        }
      })
      .addCase(deleteLocation.rejected, (state) => {
        state.loading.location = false;
      })
      .addCase(clearLocalLocations, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveLocation, state => {
        state.location = initialState.location;
      })
  }
})

export default slice.reducer;